// Globals.js
var app = pc.Application.getApplication();

var rewardedType = "";
var completeMatchStatus = false;
var spawnAssetRandomIndexes = [];
var isTutorialStageComplete = false;
var playingMiniGameName = "";
var playExtraTime = false;
var timer = 0;
var _remainTime = 0;
var matchObjectCounter = 0;
var spawnPositions = "";
var matchThemAllButtonClick = false;
var showPlaceModUI = false;

const gamestatus = {
	Wait: 1,
	Play: 2,
	Win: 3,
	Lose: 4,
    OfferPlay: 5,
    Quit: 6,
    Resume: 7,
    Pause: 8
};

const gamePlayMode = {
    Tutorial : 0,
    Normal: 1,
    Places: 2,
    MiniGame: 3
};

const adsType = {
    FirstExtraTime : 0,
    MatchThemAllExtraTime: 1,
    FailExtraTime: 2,
    ShakeExtraTime: 3,
    JokerMiniAttentionGame: 4,
    JokerMiniWordGame: 5,
    JokerMiniLinkGame: 6,
    JokerMiniMathGame : 7,
    Interstitial: 8,
    InterstitialFinishWinGame: 9,
    InterstitialFinishFailGame: 10
};

const adsEnum = {
	Interstitial: 0,
	Offer: 1,
    ChallengeOffer: 2,
    ChallengeExtraTime: 3,
    MatchThemAll: 4,
    ShakeBoard: 5,
    JokerMiniWordGame: 6,
    JokerMiniAttentionGame: 7,
    JokerMiniLinkGame: 8,
    JokerMiniMathGame: 9
};

const adsGameFinishEnum = {
    Lose: 0,
    Win: 1,
    CompleteMatch: 2
};

let status = gamestatus.Wait;

var UserData = function(){
    this.level = 0;
    this.score = 0;
    this.userScore = 0;
    this.newPlayer = true;
    this.placeMode = false;
    this.unlockLevel = false;
    this.unlockFriends = 0;
    this.shakeTutorial = false;
    this.jokerTutorial = false;
    this.interruption = 0;
    this.roomAssets = [];
    this.lastTimeProgressBar = null;
    this.savedMatchedObjectCount = null;
    this.gameMode = gamePlayMode.Normal;
    this.gameSound = true;
};

var DefaultUserData = function () {

    this.level = 0;
    this.score = 0;
    this.levelID = 1;
    this.unlockFriends = 0;
    this.allLevelUnlock = false;
    this.newPlayer = true;
    this.shakeTutorial = false;
    this.jokerTutorial = false;
    this.interruption = 0;
    this.roomAssets = [];
    this.lastTimeProgressBar = null;
    this.savedMatchedObjectCount = null;
};

var Cloud = function () {
    this.gameVersion = "v1.2.8";
    this.shakeTutorial = false;
    this.jokerTutorial = false;
    this.interruption = 0;
    this.backupData = new BackupDataInfo();
};

var ExtraInfo = function () {
    this.roomAssets = [];
    this.lastTimeProgressBar = null;
    this.savedMatchedObjectCount = null;
};

var BackupDataInfo = function() {
    this.levelData = new LevelData();
    this.extraInfo = new ExtraInfo();
};

var LevelData = function(){
    this.levelID = 0;
    this.levelName = null;
    this.levelItem = null;
    this.objectCount = null;
    this.time = null;
    this.levelTemplate = null;
    this.levelRoom = null;
    this.minObjectCount = 0;
};

var PlaceData = function(){
    this.levelID = 0;
    this.levelName = null;
    this.levelItem = null;
    this.objectCount = 0;
    this.time = 0;
    this.levelTemplate = null;
    this.levelRoom = null;
    this.minObjectCount = 0;
};

var EventData = function() {
    this.eventId = 0;
    this.eventName = null;
    this.objectCount = null;
    this.time = 0;
    this.assetName = null;
    this.assetTag = null;
    this.matchKey = null;
    this.spawnedArrayList = "";
    this.mathChallengeOperationKey = null;
};

function createSpawnAssetsRandomIndexArray() {

    let spawnObjectCount = PlayerManager.instance.spawnObjectCountByUserScore();
    spawnAssetRandomIndexes = [];

    while (spawnAssetRandomIndexes.length < spawnObjectCount) {
        var r = Math.floor(Math.random() * spawnObjectCount);
        if (spawnAssetRandomIndexes.indexOf(r) === -1) spawnAssetRandomIndexes.push(r);
    }
}

function helperModelItem(inputKey) {
    
    if (inputKey == "LivingRoom") {
        return "LivingItem";
    }
    else if (inputKey == "Kitchen") {
        return "KitchenItem";
    }
    else if (inputKey == "KidsRoom") {
        return "KidsItem";
    }
    else if (inputKey == "Food") {
        return "FoodItem";
    }
    else if (inputKey == "FarmersMarket") {
        return "FarmersItem";
    }
    else if (inputKey == "Cellar") {
        return "CellarItem";
    }
    else if (inputKey == "HobbyRoom") {
        return "HobbyItem";
    }
    else if (inputKey == "School") {
        return "SchoolItem";
    }
    else if (inputKey == "Sport") {
        return "SportItem";
    }
    else if (inputKey == "Bedroom") {
        return "BedroomItem";
    }
}

function attentionPreloadKey(roomName){

    if (roomName == "FarmersMarket") {
        return "FarmersItem";
    }
    else if (roomName == "LivingRoom") {
        return "LivingItem";
    }
    else if (roomName == "Kitchen") {
        return "KitchenItem";
    }
    else if (roomName == "KidsRoom") {
        return "KidsItem";
    }
    else if (roomName == "Food") {
        return "FoodItem";
    }
    else if (roomName == "Cellar") {
        return "CellarItem";
    }
}

async function prepareMiniGameData(miniGameIndex,callback){
   
    var preloadAssetList = [];

    if (miniGameIndex == 6) {
        var themeKeyArray = GameManager.instance.eventData.assetTag.split(",");
        let selectedIndex = Math.floor(Math.random() * themeKeyArray.length);
        let selectedThemeKey = themeKeyArray[selectedIndex];
        var excludeAssets = app.assets.find('LinkGameData.json').resource;
        let excludeAsset = excludeAssets[selectedThemeKey];

        var excludeAssetArray = excludeAsset.toString().split(",");
        var spawnAssetList = GameManager.instance.eventData.assetName.split(",");

        for (j = 0; j < excludeAssetArray.length; j++) {
            for (i = 0; i < spawnAssetList.length; i++) {

                if (spawnAssetList[i] == excludeAssetArray[j]) {
                    spawnAssetList.splice(i, 1);
                    break;
                }
                if (selectedThemeKey == "Music") {
                    if (spawnAssetList[i] == "HobbyRoom") {
                        spawnAssetList.splice(i, 1);
                    }
                }
            }
        }
        let shuffledArray = shuffle(spawnAssetList);
        let splittedArray = shuffledArray.slice(0, 2);

        randomSpawnArray1 = app.assets.findByTag(helperModelItem(shuffledArray[0]));
        randomSpawnArray2 = app.assets.findByTag(helperModelItem(shuffledArray[1]));

        preloadAssetList.push(selectedThemeKey + "Item");

        if (randomSpawnArray1.length > 26) {
            preloadAssetList.push(helperModelItem(shuffledArray[0]));
        }
        else {
            preloadAssetList.push(helperModelItem(shuffledArray[0]));
            preloadAssetList.push(helperModelItem(shuffledArray[1]));
        }

        GameManager.instance.eventData.matchKey = selectedThemeKey;
        GameManager.instance.eventData.spawnedArrayList = splittedArray;
        //console.log("Preload Asset List: " + preloadAssetList);
        callback(preloadAssetList);
    }
    else if (miniGameIndex == 4) {

        let AttentionRoomArray = GameManager.instance.eventData.assetTag.split(",");
        let randomRoomNumber = Math.floor(Math.random() * AttentionRoomArray.length);
        let selectedRoom = AttentionRoomArray[randomRoomNumber];

        let attentionObjectArray = app.assets.find('AttentionGameData.json').resource;
        let selectedAttentionObjectArray = attentionObjectArray[selectedRoom];
        var selectedAttentionObjectKey = [];

        while (selectedAttentionObjectKey.length < 3) {
            var r = Math.floor(Math.random() * selectedAttentionObjectArray.length);
            if (selectedAttentionObjectKey.indexOf(selectedAttentionObjectArray[r]) === -1) selectedAttentionObjectKey.push(selectedAttentionObjectArray[r]);
        }

        findByAttentionObjects = [...selectedAttentionObjectKey];
        GameManager.instance.eventData.matchKey = selectedAttentionObjectKey;
        GameManager.instance.eventData.assetTag = selectedRoom;

        preloadAssetList = helperModelItem(selectedRoom);
        //console.log("Preload Asset List: " + preloadAssetList);
        callback(preloadAssetList);
    }
    else {
        preloadAssetList = GameManager.instance.eventData.assetTag + "Item";
        callback(preloadAssetList);
    }
}

function clearCacheFunction() {

    localStorage.removeItem("level");
    localStorage.removeItem("levelID");
    localStorage.removeItem("levelName");
    localStorage.removeItem("levelItem");
    localStorage.removeItem("time");
    localStorage.removeItem("objectCount");
    localStorage.removeItem("assetName");
    localStorage.removeItem("unlockLevel");
    localStorage.removeItem("score");
    localStorage.removeItem("player");
    localStorage.removeItem("lastTimeBar");
    localStorage.removeItem("matchItems");
    localStorage.removeItem("isContinue");
    localStorage.removeItem("backupLevelData");
    localStorage.removeItem("extraInfo");
    localStorage.removeItem("interruption");
    localStorage.removeItem("minObjectCount");
    localStorage.removeItem("levelRoom");
    localStorage.removeItem("levelRoom");
    localStorage.removeItem("version");
    localStorage.removeItem("testDrive");
    localStorage.removeItem("customEventPlayed");
}

function pauseGameEvent () {
    GameManager.instance.PauseGame();
}

function resumeGameEvent () {
    GameManager.instance.ResumeGame();
}

function clearUserData() {
    localStorage.removeItem("PairUp:PlayerData");
    localStorage.removeItem("PairUp:isNewUser");
}

function setFillMode() {
    if (pc.platform.mobile) {
        pc.Application.getApplication().setCanvasFillMode(pc.FILLMODE_FILL_WINDOW);
        document.getElementById("application-canvas").style.height = "100%";
        document.getElementById("application-canvas").style.margin = 0;
    }
}

function initializeResize() {
    if (pc.platform.mobile) {
        //console.log("MobileMod");
        
        if (window.innerWidth > window.innerHeight) {
            //console.log("Landscape Mod");
            document.getElementById("application-canvas").style.height = "100%";
            document.getElementById("application-canvas").style.width = `${window.innerHeight * 9 / 16}px`;
            document.getElementById("application-canvas").style.margin = 'auto';

            
        }
        else {
            //console.log("Portrait Mod");
            document.getElementById("application-canvas").style.height = "100%";
            document.getElementById("application-canvas").style.width = "100%";
        }
    }   
}


